export default __webpack_public_path__ + "static/media/background_head_mobile.0fd8b752.svg";